


















import Vue, { PropType } from "vue";
import ImageView from "@/components/atoms/ImageView.vue";
import format from "date-fns/format";
import { Novel } from "@/lib/models";
import PinIcon from "icons/Pin.vue";
import PinOutlineIcon from "icons/PinOutline.vue";
import isMobile from "ismobilejs";

interface Props {
  novel: Novel;
}

interface Data {
  isMouseHover: boolean;
}

interface Computed {
  pinned?: boolean;
  toUpdatedAt: string;
  getImageKey?: string;
  isPC: boolean;
}

interface Methods {
  onMouseOver(): void;
  onMouseLeave(): void;
  onClickPinned(): void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ImageView, PinIcon, PinOutlineIcon },
  props: {
    novel: Object as PropType<Novel>,
  },
  data() {
    return {
      isMouseHover: false,
    };
  },
  computed: {
    pinned() {
      const { novel } = this;
      return novel.pinned;
    },
    toUpdatedAt() {
      const { novel } = this;
      const { updatedAtLatestDataInNovel } = novel;

      if (updatedAtLatestDataInNovel) return format(updatedAtLatestDataInNovel, "YYYY/MM/DD");
      return "-";
    },
    getImageKey() {
      const {
        novel: { novelId, image },
      } = this;
      if (image && image.startsWith("file:")) {
        return `file:novels/${novelId}/cover.jpg`;
      }
      return image;
    },
    isPC() {
      return !isMobile().any;
    },
  },
  methods: {
    onMouseOver() {
      this.isMouseHover = true;
    },
    onMouseLeave() {
      this.isMouseHover = false;
    },
    async onClickPinned() {
      const { $store, novel } = this;

      novel.pinned = novel.pinned ? false : true;

      await $store.dispatch("novelModule/updateNovel", novel);
    },
  },
});
